import { useState } from "react";
import useUser from "../../hooks/useUser";
import { checkAvailability } from "../../http/bookingAPI";
import { IBookingRequestModel } from "../../interfaces/requests/IBookingRequestModel";
import ClassicButton from "../UI/ClassicButton/ClassicButton";
import AlertModal from "../UI/MyAlert/MyAlert";

interface PaymentWidgetProps {
    amount: number;
    description: string;
    bookings: IBookingRequestModel[];
    email: string;
    agreement: boolean;
    onPaymentSuccess: () => void; 
    userEmail: string;
    eventTitle: string
    eventDate: Date;
}

const PaymentWidget: React.FC<PaymentWidgetProps> = ({ amount, description, bookings, email, agreement, onPaymentSuccess, userEmail, eventTitle, eventDate }) => {
    const user = useUser();
    const [alertVisible, setAlertVisible] = useState<boolean>(false);
    const [alertMessage, setAlertMessage] = useState<string>('');
    
    const handlePayment = async () => {
        if (!email) {
            setAlertMessage('Пожалуйста, заполните поле почты.');
            setAlertVisible(true);
            return;
        }
        
        if (!agreement) {
            setAlertMessage('Пожалуйста, примите условия предоставления услуг.');
            setAlertVisible(true);
            return;
        }
        
        const response = await checkAvailability(bookings);
        if (response === true) {
            const widget = new (window as any).cp.CloudPayments();
            
            const date = new Date(eventDate).toLocaleDateString('ru-RU', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric'
            })
            
            widget.pay('charge',
                {
                    publicId: process.env.REACT_APP_CLOUDPAYMENT_PUBLICID,
                    description: description,
                    amount: amount,
                    currency: 'RUB',
                    accountId: user.user?.email,
                    skin: 'classic',
                    data: {
                        bookings: bookings,
                        userEmail: userEmail,
                        eventTitle: eventTitle,
                        eventDate: date,
                    },
                    payer: {
                        firstName: user.user?.firstname,
                        lastName: user.user?.lastname,
                        phone: user.user?.phone,
                    }
                },
                {
                    onSuccess: function () {
                        onPaymentSuccess();
                    },
                    onFail: function () {
                        setAlertMessage(`Ошибка оплаты.`);
                        setAlertVisible(true);
                    }
                }
            );
        } else {
            setAlertMessage('Нет свободных билетов');
            setAlertVisible(true);
        }
    };
    
    return (
        <>
            <ClassicButton 
                onClick={handlePayment}
                fontSize='15px'
                padding='5px 10px'
                borderRadius='20px'
            >
                Оплатить
            </ClassicButton>
            
            <AlertModal visible={alertVisible} setVisible={setAlertVisible} autoCloseTime={2500}>
                {alertMessage}
            </AlertModal>
        </>
    );
};

export default PaymentWidget;